import { render } from "./UseCasesDetailsDCT.vue?vue&type=template&id=76138530"
import script from "./UseCasesDetailsDCT.vue?vue&type=script&lang=js"
export * from "./UseCasesDetailsDCT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__